import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const MpesaLoading = ({ id, isMpesaLoading }) => {
  const controlsFirst = useAnimation();
  const controlsSecond = useAnimation();
  const controlsThird = useAnimation();

  useEffect(() => {
    if (isMpesaLoading) {
      controlsFirst.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0,
        },
      });

      controlsSecond.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.2,
        },
      });

      controlsThird.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.4,
        },
      });
    } else {
      controlsFirst.stop();
      controlsSecond.stop();
      controlsThird.stop();
    }
  }, [isMpesaLoading, controlsFirst, controlsSecond, controlsThird]);

  return (
    <SlidePanel isOpen={isMpesaLoading} onClose={() => {}}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        {/* Optional Close (hidden logic-safe) */}
        <div className="absolute top-0 right-0 h-[40px] w-[40px] opacity-0">
          <X />
        </div>

        <div className="flex flex-col h-full justify-center mt-5 px-10">
          {/* ✅ CENTERED LOADING DOTS */}
          <div className="flex items-center justify-center mb-6">
            <motion.div
              className="bg-black w-2 h-2 rounded-full mx-2"
              animate={controlsFirst}
            />
            <motion.div
              className="bg-black w-2 h-2 rounded-full mx-2"
              animate={controlsSecond}
            />
            <motion.div
              className="bg-black w-2 h-2 rounded-full mx-2"
              animate={controlsThird}
            />
          </div>

          {/* TEXT */}
          <div className="text-[#005C53] text-[12px] mb-2">Make sure that</div>

          <div className="flex items-center gap-3 mt-2">
            <svg
              width="13"
              height="8"
              viewBox="0 0 13 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5578 0.231509C12.4728 0.158151 12.3717 0.099926 12.2602 0.0601915C12.1488 0.0204571 12.0293 0 11.9085 0C11.7878 0 11.6683 0.0204571 11.5568 0.0601915C11.4454 0.099926 11.3443 0.158151 11.2592 0.231509L4.44622 6.07013L1.58384 3.61259C1.49557 3.53961 1.39137 3.48223 1.27719 3.44372C1.16301 3.40521 1.04109 3.38633 0.91838 3.38814C0.795672 3.38996 0.674584 3.41244 0.562029 3.45431C0.449474 3.49618 0.347657 3.55661 0.26239 3.63215C0.177124 3.7077 0.110078 3.79687 0.0650811 3.89459C0.0200842 3.99231 -0.00198313 4.09666 0.000139844 4.20167C0.00226282 4.30669 0.0285344 4.41032 0.0774541 4.50665C0.126374 4.60298 0.196984 4.69012 0.285253 4.76309L3.79693 7.76849C3.88194 7.84185 3.98309 7.90007 4.09453 7.93981C4.20597 7.97954 4.3255 8 4.44622 8C4.56695 8 4.68648 7.97954 4.79792 7.93981C4.90936 7.90007 5.0105 7.84185 5.09552 7.76849L12.5578 1.38201C12.6507 1.30872 12.7247 1.21977 12.7754 1.12077C12.8261 1.02176 12.8522 0.914848 12.8522 0.806761C12.8522 0.698675 12.8261 0.59176 12.7754 0.492754C12.7247 0.393749 12.6507 0.304798 12.5578 0.231509Z"
                fill="black"
              />
            </svg>
            <p className="font-[14px] text-[#000000] font-normal">
              Member’s M-Pesa SIM is active
            </p>
          </div>

          <div className="flex items-center gap-3 mt-2 mb-2">
            <svg
              width="13"
              height="8"
              viewBox="0 0 13 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5578 0.231509C12.4728 0.158151 12.3717 0.099926 12.2602 0.0601915C12.1488 0.0204571 12.0293 0 11.9085 0C11.7878 0 11.6683 0.0204571 11.5568 0.0601915C11.4454 0.099926 11.3443 0.158151 11.2592 0.231509L4.44622 6.07013L1.58384 3.61259C1.49557 3.53961 1.39137 3.48223 1.27719 3.44372C1.16301 3.40521 1.04109 3.38633 0.91838 3.38814C0.795672 3.38996 0.674584 3.41244 0.562029 3.45431C0.449474 3.49618 0.347657 3.55661 0.26239 3.63215C0.177124 3.7077 0.110078 3.79687 0.0650811 3.89459C0.0200842 3.99231 -0.00198313 4.09666 0.000139844 4.20167C0.00226282 4.30669 0.0285344 4.41032 0.0774541 4.50665C0.126374 4.60298 0.196984 4.69012 0.285253 4.76309L3.79693 7.76849C3.88194 7.84185 3.98309 7.90007 4.09453 7.93981C4.20597 7.97954 4.3255 8 4.44622 8C4.56695 8 4.68648 7.97954 4.79792 7.93981C4.90936 7.90007 5.0105 7.84185 5.09552 7.76849L12.5578 1.38201C12.6507 1.30872 12.7247 1.21977 12.7754 1.12077C12.8261 1.02176 12.8522 0.914848 12.8522 0.806761C12.8522 0.698675 12.8261 0.59176 12.7754 0.492754C12.7247 0.393749 12.6507 0.304798 12.5578 0.231509Z"
                fill="black"
              />
            </svg>
            <p className="font-[14px] text-[#000000] font-normal">
              You entered correct M-Pesa PIN to authorise transaction
            </p>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default MpesaLoading;
